import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var propTypes = {
  /**
   * A button or link
   */
  button: PropTypes.node,
  /**
   * Unformatted content
   */
  children: PropTypes.element,
  /**
   * Custom class for styling
   */
  className: PropTypes.string,
  /**
   * Any pattern library icon (if no icon is specified, an icon will not display)
   */
  icon: PropTypes.node,
  /**
   * The component's title
   */
  title: PropTypes.node,
  /**
   * Heading level of the title
   */
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /**
   * content below the title
   */
  message: PropTypes.node,
  /**
   * Smaller format layout
   */
  smallLayout: PropTypes.bool
};
var defaultProps = {
  headingLevel: 'h2',
  smallLayout: false
};
export function Result(props) {
  var button = props.button,
    children = props.children,
    className = props.className,
    headingLevel = props.headingLevel,
    icon = props.icon,
    title = props.title,
    message = props.message,
    smallLayout = props.smallLayout;
  var TitleTag = headingLevel;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("asc-result ".concat(className), {
      'asc-result--small': smallLayout
    })
  }, icon && /*#__PURE__*/React.cloneElement(icon, {
    customSize: smallLayout ? '56px' : '88px',
    className: classNames('asc-result--icon', {
      'asc-mb-0': !title && !message
    })
  }), title && /*#__PURE__*/React.createElement(TitleTag, {
    className: classNames('asc-result--title', {
      'asc-h': !smallLayout,
      'asc-sub-h--medium': smallLayout,
      'asc-mb-0': !message
    })
  }, title), message && /*#__PURE__*/React.createElement("p", {
    className: classNames('asc-result--message asc-mb-0', {
      'asc-p--medium': !smallLayout,
      'asc-p--small': smallLayout
    })
  }, message), button && /*#__PURE__*/React.cloneElement(button, {
    className: "asc-result--button ".concat(button.props.className)
  }), children && children);
}
Result.propTypes = propTypes;
Result.defaultProps = defaultProps;
export default Result;